import styled from "styled-components";


const LoginContent = styled.div`
/* Card */
position: relative;
overflow: hidden;
box-sizing: border-box;

/* Auto layout */
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;

gap: 32px;


width: 100%;
min-height: 215px;

background: ${({ theme }) => `linear-gradient(${theme?.colors?.theme?.brandColor3}33, ${theme?.colors?.theme?.brandColor3}33),
                              linear-gradient(${theme?.colors?.theme?.contentBg}, ${theme?.colors?.theme?.contentBg})`};
border-radius: 32px;
box-sizing: border-box;
padding: 32px;
@media (max-width: 400px) {
  padding: 8px;
}
`;

const HeadingContainerStyled = styled.div`
display: flex;
flex-direction: row;
align-items: flex-start;
padding: 0px;
gap: 16px;
box-sizing: border-box;
width: 100%;
max-width: 340px;
min-height: 75px;

@media (max-width: 400px) {
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px;
}

`;

const ContentTitleStyled = styled.div`
display: flex;
flex-direction: column;
align-items: center;
padding: 0px;
gap: 8px;
box-sizing: border-box;
p {
  width: 100%;
  box-sizing: border-box;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  color: ${({ theme }) => theme?.colors?.text?.headings};
}
`;

const TitleStyled = styled.h3`
/* Título de Misión o Campaña */
width: 100%;
max-width: 260px;
height: 29px;

font-style: normal;
font-weight: 700;
font-size: 24px;
line-height: 120%;
/* identical to box height, or 29px */

color: ${({ theme }) => theme?.colors?.theme?.brandColor3};

`;

export { LoginContent, HeadingContainerStyled, TitleStyled, ContentTitleStyled };
